module.exports = __webpack_public_path__ + "media/applicants/checkbox-checked-disabled-b93bf674.png";